var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"item-menu relative"},[_c('a',{attrs:{"href":_vm.url}},[_c('span',{class:("menu-insurances__img " + (this.$i18n.locale))},[_c('img',{attrs:{"src":_vm.getImgPath()}})]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }